import { Directive, Input, OnInit, ViewContainerRef } from '@angular/core';
import { ImageComponent } from '../../blog/blog-blocks/image/image.component';
import { TextSectionComponent } from '../../blog/blog-blocks/text-section/text-section.component';
import { CollectionProductsComponent } from '../../blog/blog-blocks/collection-products/collection-products.component';
import { LinkBlockComponent } from '../../blog/blog-blocks/link-block/link-block.component';
import { ProductComponent } from '../../blog/blog-blocks/product/product.component';
import { SplitSectionComponent } from '../../blog/blog-blocks/split-section/split-section.component';
import { SimpleCarouselComponent } from '../../blog/blog-blocks/simple-carousel/simple-carousel.component';
import { SimpleGridComponent } from '../../blog/blog-blocks/simple-grid/simple-grid.component';
import { MediaLinksComponent } from '../../blog/blog-blocks/media-links/media-links.component';
import { BlockMargin } from '../../service/article/article.service';

@Directive({
    selector: '[appComponentFactory]',
    standalone: false
})
export class ComponentFactoryDirective implements OnInit
{
  @Input() private name: string;
  @Input() private section: any;
  @Input() private margin: BlockMargin;

  private componentTypes = {
    'FullScreenImageSection': ImageComponent,
    'ImageWithCaptionSection': ImageComponent,
    'ImageWithBigCaptionSection': ImageComponent,
    'ProductSliderSection': CollectionProductsComponent,
    'TextSection': TextSectionComponent,
    'SplitSection': SplitSectionComponent,
    'ImageSubsection': ImageComponent,
    'TextSubsection': TextSectionComponent,
    'ProductSubsection': ProductComponent,
    'CollectionProductsSection': CollectionProductsComponent,
    'CenterLinkBlockSection': LinkBlockComponent,
    'SimpleCarousel': SimpleCarouselComponent,
    'SimpleGrid': SimpleGridComponent,
    'MediaLinks': MediaLinksComponent
  };

  constructor(public viewContainerRef: ViewContainerRef) { }

  private create(): void
  {
    try
    {
      const viewRef = this.viewContainerRef;
      viewRef.clear();
      const componentRef: any = viewRef.createComponent(this.componentTypes[this.name]);
      componentRef.instance.section = this.section;
      componentRef.instance.type = this.name;
      componentRef.instance.margin = this.margin;
    }
    catch
    {
    }
  }

  ngOnInit()
  {
    this.name = encodeURIComponent(this.name);
    this.create();
  }
}
